<template lang="pug">
v-container(fluid pa-0 class="home-container tw-h-full")
  div(class="home-navbar tw-absolute tw-z-50 tw-pt-10")
    v-app-bar(
      flat
      app
      dense
      rounded
      max-width="1200px"
      :color="appBarBg"
      class=" tw-mx-auto tw-mt-6 tw-rounded-full "
    )
      v-row(align="center" class="home-navbar-row")
        v-col(cols="auto" class="home-navbar-brand")
          router-link(:to="{ path: '/' }")
            v-img(src="@/assets/images/kubiqa-logo.svg" width="120px")
        v-col(cols="auto" class="d-none d-md-flex")
          router-link(:to="{ path: '#product' }")
            span(class="tw-text-blueGray-darken-1 tw-font-semibold tw-capitalize ") {{ $t('Pages.Home.product') }}
        v-col(cols="auto" class="d-none d-md-flex")
          router-link(:to="{ path: '#features' }")
            span(class="tw-text-blueGray-darken-1 tw-font-semibold tw-capitalze") {{ $t('Pages.Home.features') }}
        v-col(cols="auto" class="d-none d-md-flex")
          router-link(:to="{ path: '#pricing' }")
            span(class="tw-text-blueGray-darken-1 tw-font-semibold tw-capitalize") {{ $t('Pages.Home.pricing') }}
        v-col(class="flex-grow-1")

        v-col(cols="auto" class="home-navbar-actions")
          v-btn(:to="{ name: 'Login' }" outlined :large="$vuetify.breakpoint.mdAndUp" :small="$vuetify.breakpoint.smAndDown" elevation="0" color="#2f53c9" class="home-login-button tw-rounded-md")
            span(class="tw-capitalize tw-font-semibold") {{ $t('Common.login') }}
          v-btn(:large="$vuetify.breakpoint.mdAndUp" :small="$vuetify.breakpoint.smAndDown" elevation="0" color="#2f53c9" class="tw-rounded-md" @click="joinEarlyAccess('navigation')")
            span(class="tw-capitalize tw-font-semibold") {{ $t('Pages.Home.primaryCTA') }}

  v-container(fluid pa-0 class="home-hero-container")
    v-row(no-gutters)
      v-col(class="home-hero-background")
        div(class="tw-relative tw-z-0 tw-overflow-hidden")
          v-img(src="@/assets/images/web/rectangle.svg")

      v-col(class="home-hero-content tw-absolute tw-z-10 tw-w-full")
        v-container(fluid class="tw-w-5/6")
          v-row(class="home-hero-spacer tw-h-64")

          v-row(no-gutters align="center" justify="space-around")
            v-col(:cols="$vuetify.breakpoint.smAndDown ? 12 : 4" class="home-hero-copy")
              v-row(no-gutters)
                v-col(cols="auto")
                  span(class="h2") {{ $t('Pages.Home.headingFirst') }}
              v-row(no-gutters class="tw-pt-3")
                v-col(cols="auto")
                  v-chip(small color="indigo lighten-5" text-color="indigo darken-3" class="tw-font-bold") {{ $t('Pages.Home.earlyAccessBadge') }}
              v-row(no-gutters class="tw-pt-6")
                v-col
                  p(class=" text-secondary h4") {{ $t('Pages.Home.textFirst') }}
              v-row
                v-col
                  v-btn(x-large elevation="0" color="#2f53c9" class="tw-rounded-md" @click="joinEarlyAccess('hero')")
                    span(class="tw-capitalize tw-font-semibold") {{ $t('Pages.Home.primaryCTA') }}

            v-col(:cols="$vuetify.breakpoint.smAndDown ? 12 : 'auto'" class="home-hero-image")
              v-img(src="@/assets/images/web/screen-1.png" max-width="700px")

    v-row(id="product" justify="center" class="home-product-section tw-overflow-hidden tw-pb-4 tw-pt-16")
      v-col(cols="12")
        v-row(justify="center")
          v-col(cols="12")
            span(class="h2") Publish with one click and start capturing leads
        v-row(no-gutters justify="center" class="tw-pt-6")
          v-col(cols="12")
            p(class=" text-secondary h4") All plans include a professionally designed website showcasing all of your listings
        v-row(align="center" class="home-feature-cards tw-pt-10 tw-w-5/6 tw-mx-auto")
          v-col(cols="12" md="4" class="tw-px-10")
            v-row(no-gutters)
              v-col
                v-row(justify="center")
                  v-col(cols="auto")
                    v-img(src="@/assets/images/web/graphic-1.svg")
                v-row(justify="center")
                  v-col(cols="auto")
                    span(class="h3") Add your listing
                v-row(justify="center")
                  v-col(class="text-center")
                    span(class="text-secondary") Upload as many photos as you want, add the details, amenities & publish.

          v-col(cols="12" md="4" class="feature-container tw-py-24 tw-px-10")
            v-row(no-gutters)
              v-col
                v-row(justify="center")
                  v-col(cols="auto")
                    v-img(src="@/assets/images/web/graphic-2.svg")
                v-row(justify="center")
                  v-col(cols="auto")
                    span(class="h3") Capture leads
                v-row(justify="center")
                  v-col(class="text-center")
                    span(class="text-secondary") Anyone contacting you about a specific listing, will come straight into your Kubiqa Inbox.

          v-col(cols="12" md="4" class="tw-px-10")
            v-row(no-gutters)
              v-col
                v-row(justify="center")
                  v-col(cols="auto")
                    v-img(src="@/assets/images/web/graphic-3.svg")
                v-row(justify="center")
                  v-col(cols="auto")
                    span(class="h3") Manage your sales pipeline
                v-row(justify="center")
                  v-col(class="text-center")
                    span(class="text-secondary") Convert your leads to opportunites to manage each stage of the sales process and gain visibility.
    v-row(class="home-feature-showcase tw-pt-64 tw-overflow-hidden")
      v-col(cols="12" id="features")
        v-row(align="center" justify="center")
          v-col(class="home-feature-decoration")
            div(class="tw-relative tw-z-0 tw-w-full tw-overflow-hidden")
              v-img(src="@/assets/images/web/rectangle-2.svg")

          v-col(class="home-feature-carousel tw-absolute tw-z-10 tw-mx-auto tw-mt-2")
            v-carousel(:show-arrows="false" :hide-delimiter-background="true" :height="$vuetify.breakpoint.smAndDown ? '500px' : '660px'")
              v-carousel-item
                v-container(fluid class="tw-w-full tw-mx-auto")
                  v-row(justify="space-around")
                    v-col
                      v-row(justify="center")
                        v-col(cols="auto")
                          span(class="h2") All your leads in one place
                      v-row(no-gutters justify="center" class="tw-pt-3")
                        v-col(cols="auto")
                          p(class=" text-secondary h4") View and manage your leads straight from your inbox
                  v-row(justify="space-around")
                    v-col(cols="auto")
                      v-img.home-feature-screenshot(src="@/assets/images/web/screen-2.png" max-width="820px")
              v-carousel-item
                v-container(fluid class="tw-w-full tw-mx-auto")
                  v-row(justify="space-around")
                    v-col
                      v-row(justify="center")
                        v-col(cols="auto")
                          span(class="h2") Full view of your sales pipeline
                      v-row(no-gutters justify="center" class="tw-pt-3")
                        v-col(cols="auto")
                          p(class=" text-secondary h4") Keep track of all your opportunities at every stage
                  v-row(justify="space-around")
                    v-col(cols="auto")
                      v-img.home-feature-screenshot(src="@/assets/images/web/screen-opps.png" max-width="800px")
              v-carousel-item
                v-container(fluid class="tw-w-full tw-mx-auto")
                  v-row(justify="space-around")
                    v-col
                      v-row(justify="center")
                        v-col(cols="auto")
                          span(class="h2") Manage your listings
                      v-row(no-gutters justify="center" class="tw-pt-3")
                        v-col(cols="auto")
                          p(class=" text-secondary h4") Keep your listings up to date, publish & share with your prospects
                  v-row(justify="space-around")
                    v-col(cols="auto")
                      v-img.home-feature-screenshot(src="@/assets/images/web/screen-listings.png" max-width="820px")
              v-carousel-item
                v-container(fluid class="tw-w-full tw-mx-auto")
                  v-row(justify="space-around")
                    v-col
                      v-row(justify="center")
                        v-col(cols="auto")
                          span(class="h2") Contact directory
                      v-row(no-gutters justify="center" class="tw-pt-3")
                        v-col(cols="auto")
                          p(class=" text-secondary h4") View all your contact's details, their activity, opportunities and properties
                  v-row(justify="space-around")
                    v-col(cols="auto")
                      v-img.home-feature-screenshot(src="@/assets/images/web/screen-contacts.png" max-width="820px")

        v-row.justify-space-around.home-feature-cta
          v-col(cols="auto")
            v-btn(x-large elevation="0" color="#2f53c9" class="tw-rounded-md" @click="joinEarlyAccess('features')")
              span(class="tw-capitalize tw-font-semibold") {{ $t('Pages.Home.primaryCTA') }}

    v-row(id="pricing" no-gutters class="home-pricing-section tw-pt-10" justify="center" align="start")
      v-col(class="home-pricing-decoration tw-absolute tw-pt-10")
        div(class="tw-relative w-z-0 tw-w-full")
          v-img(src="@/assets/images/web/rectangle-3.svg")

      v-col(class="home-pricing-decoration")
        div(class="tw-relative tw-z-10 tw-w-full tw-overflow-hidden")
          v-img(src="@/assets/images/web/rectangle-4.svg")

      v-col(cols="10" class="home-pricing-card tw-absolute tw-z-20 tw-mx-auto tw-mt-4")
        kubiqa-misc-early-access-pricing
</template>

<script>
import { EARLY_ACCESS_REGISTRATION_ROUTE } from '@/config/earlyAccess';
import { trackEarlyAccessEvent } from '@/services/AnalyticsService';

export default {
  data() {
    return {
      appBarBg: 'rgba(0,0,0,0)',
    };
  },
  mounted() {
    window.onscroll = () => {
      this.appBarChangeColor();
    };
  },
  methods: {
    joinEarlyAccess(placement) {
      trackEarlyAccessEvent(this, 'early_access_cta_clicked', { placement });
      this.$router.push(EARLY_ACCESS_REGISTRATION_ROUTE);
    },
    appBarChangeColor() {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        this.appBarBg = '#ffffff';
        this.appBarClass = 'scroll';
      } else {
        this.appBarBg = 'rgba(0,0,0,0)';
        this.appBarClass = 'top';
      }
    },
  },
};
</script>

<style lang="stylus">
.feature-container
    background: #FFFFFF;
    box-shadow: 0 4px 15px 0 rgba(7,42,68,0.10);
    border-radius: 10px;

.pricing-container
    background: #FFFFFF;
    border-radius: 10px;
    height: 400px;

.pricing-container-featured
    background: #FFFFFF;
    box-shadow: 0 4px 15px 0 rgba(7,42,68,0.10);
    border-radius: 10px;
    height: 420px;

.v-carousel__controls__item
    color: #919AA3 !important;

.v-carousel__controls__item.v-item__active
    opacity: 0.3;
    background: #919AA3;

.home-navbar-actions
  display: flex
  align-items: center
  gap: 12px

.home-login-button
  color: #283593 !important
  background-color: #e8eaf6 !important
  border: 1px solid #c5cae9
  letter-spacing: 0.25px

.home-login-button:hover
  background-color: #dce0f2 !important

.home-login-button:focus-visible
  outline: 2px solid #283593 !important
  outline-offset: 3px

@media (max-width: 959px)
  .home-navbar
    left: 0
    right: 0
    width: 100%
    padding: 8px 12px 0

  .home-navbar .v-app-bar
    margin: 0 auto !important
    border-radius: 12px !important

@media (max-width: 599px)
  .home-navbar .v-toolbar__content
    height: auto !important
    padding: 8px 12px

  .home-navbar-row
    margin: 0
    justify-content: center

  .home-navbar-brand
    display: flex
    justify-content: center
    flex-basis: 100%
    padding: 4px 0 8px

  .home-navbar-actions
    padding: 4px 0

  .home-navbar-row > .flex-grow-1
    display: none

  .home-container
    max-width: 100%
    overflow-x: hidden

  .home-hero-content
    position: relative !important
    width: 100%
    padding-bottom: 24px

  .home-hero-spacer
    height: 132px !important

  .home-hero-copy
    padding: 16px 8px 0
    text-align: center

  .home-hero-copy .h2
    display: block
    font-size: 2rem
    line-height: 1.2

  .home-hero-copy p
    font-size: 1rem
    line-height: 1.5

  .home-hero-copy .v-btn
    margin-bottom: 16px

  .home-hero-image
    padding: 0 12px

  .home-hero-image .v-image
    max-width: 100% !important

  .home-product-section
    margin: 0
    padding: 32px 16px 16px !important
    overflow: visible !important

  .home-product-section > .col
    flex: 0 0 100%
    max-width: 100%

  .home-product-section .h2
    display: block
    font-size: 1.55rem
    line-height: 1.25
    text-align: center

  .home-product-section .h4
    font-size: 1rem
    line-height: 1.45
    text-align: center

  .home-feature-cards
    width: 100% !important
    margin: 16px 0 0 !important

  .home-feature-cards > .col
    padding: 10px 0 !important

  .home-feature-cards .feature-container
    padding: 24px 20px !important

  .home-feature-showcase
    margin: 0
    padding: 32px 16px 0 !important
    overflow: visible !important

  .home-feature-decoration
    display: none

  .home-feature-carousel
    position: relative !important
    flex: 0 0 100%
    max-width: 100%
    width: 100%
    margin: 0 !important
    padding: 0

  .home-feature-carousel .v-carousel
    height: 500px !important

  .home-feature-carousel .h2
    display: block
    font-size: 1.45rem
    line-height: 1.25
    text-align: center

  .home-feature-carousel .h4
    font-size: 1rem
    line-height: 1.4
    text-align: center

  .home-feature-screenshot
    max-width: 100% !important

  .home-feature-cta
    margin: 0
    padding: 8px 0 24px

  .home-pricing-section
    position: relative
    min-height: 0
    margin: 0
    padding: 24px 16px 40px !important

  .home-pricing-decoration
    display: none

  .home-pricing-card
    position: relative !important
    flex: 0 0 100%
    max-width: 100%
    width: 100%
    margin: 0 !important
    padding: 0
</style>
